import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Primary action button. Defaults to the brand-green primary variant from
 * the prototype's `.btn-primary` style.
 */
export function Button({ variant = 'primary', size = 'md', block = false, className, type = 'button', children, ...rest }) {
    const classes = [
        'kb-button',
        `kb-button--${variant}`,
        size === 'sm' && 'kb-button--sm',
        block && 'kb-button--block',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx("button", { type: type, className: classes, ...rest, children: children }));
}
//# sourceMappingURL=Button.js.map